import { render, staticRenderFns } from "./seckillGoodsList.vue?vue&type=template&id=05853219&scoped=true&"
import script from "./seckillGoodsList.vue?vue&type=script&lang=js&"
export * from "./seckillGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./seckillGoodsList.vue?vue&type=style&index=0&id=05853219&lang=stylus&scoped=true&"
import style1 from "./seckillGoodsList.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05853219",
  null
  
)

export default component.exports